import { render, staticRenderFns } from "./TutorFigure.vue?vue&type=template&id=18d88f52&scoped=true&"
import script from "./TutorFigure.vue?vue&type=script&lang=js&"
export * from "./TutorFigure.vue?vue&type=script&lang=js&"
import style0 from "./TutorFigure.vue?vue&type=style&index=0&id=18d88f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d88f52",
  null
  
)

export default component.exports